import { useEffect } from 'react';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import { useAuditorStore } from '../../stores/auditorStore';

/**
 * Composant intermédiaire : quand l'auditeur navigue vers /auditor/company/:organizationId
 * on active l'entreprise correspondante dans le store et on redirige vers le dashboard.
 */
export function AuditorCompanyRedirect() {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { auditorProfile, setActiveCompany } = useAuditorStore();
  const navigate = useNavigate();

  const company = auditorProfile?.companies.find(
    (c) => c.organization.id === organizationId
  );

  useEffect(() => {
    if (company) {
      setActiveCompany(company);
      navigate('/', { replace: true });
    }
  }, [company, setActiveCompany, navigate]);

  if (!company) {
    // Organisation introuvable dans le profil auditeur
    return <Navigate to="/auditor/clients" replace />;
  }

  // Attendre que le useEffect active l'entreprise et redirige
  return null;
}
